module.exports = __webpack_public_path__ + "img/hot_lbsq.5fe12585.svg";